import { Trans } from '@lingui/macro';
import { Box, CircularProgress } from '@mui/material';
import { type FC } from 'react';

/** Marca un dato que todavía espera la respuesta del equipo: nunca se muestra uno viejo en su lugar. */
export const AwaitingDevice: FC = () => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
    <CircularProgress size={12} thickness={5} color="inherit" />
    <Trans>Esperando al equipo…</Trans>
  </Box>
);
